import { useState } from "react"
import Card from "./Card"

export default function Container({ items }) {
  const [openIndex, setOpenIndex] = useState(null)

  const handleToggle = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index))
  }

  return (
    <div className="mx-auto w-full max-w-[610px]">
      <div className="flex flex-col gap-2 lg:gap-4">
        {items.map((item, index) => (
          <Card
            key={index}
            question={item.question}
            answer={item.answer}
            isOpen={openIndex === index} onToggle={() => handleToggle(index)}
          />
        ))}
      </div>
    </div>
  )
}
